import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getPayments(perPage, page) {
        return Axios.get(`${baseURL}billing/payments`, {
            params: { per_page: perPage, page: page }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response;
            }
            return [];
        });
    },
    sendSMS(data) {
        return Axios.post(`${baseURL}billing/payments/sms`, data).then(
            response => response.data.response
        );
    },
    emailReceipt(data) {
        return Axios.post(`${baseURL}billing/payments/email`, data).then(
            response => response.data.response
        );
    },
    printReceipt(paymentId) {
        return Axios.post(`${baseURL}billing/payments/receipt`, {
            payment_id: paymentId
        }).then(response => response.data.response);
    },
    removePayment(payment) {
        return Axios.post(
            `${process.env.BARRAMUNDI}billing/payments/${payment.id}`,
            payment
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
